import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import {
  Label as LabelIcon,
  DynamicFeed as DynamicFeedIcon,
  Receipt as ReceiptIcon,
  FileCopy,
  TableChart as TableChartIcon,
  InsertDriveFile,
  DashboardOutlined as DashboardIcon,
} from '@material-ui/icons';
import { Calculate as CalculateIcon } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import QCXMainLayout from '../../../components/main-layout/QCXMainLayout';
import { EXPORTACAO_MODULE } from '../../../utils/general/modules';
import { focusLockActions } from '../../../features/focus-lock/focusLockSlice';
import QCXFocusLock from '../../../components/focus-lock/QCXFocusLock';
import QCXCardMenu from '../../../shared-components/card-menu/QCXCardMenu';
import NumerarioImportacaoUtils from '../../../utils/general/numerario-importacao/NumerarioImportacaoUtils';

const useStyles = makeStyles((theme) => ({
  cardMenuContainer: {
    marginTop: theme.spacing(0),
  },
  cardMenu: {
    width: theme.spacing(100),
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  subNested: {
    paddingLeft: theme.spacing(8),
  },
  active: {
    display: 'flex!important',
  },
  noActive: {
    display: 'none!important',
    transformOrigin: '0 0 0!important',
  },
}));

export default function ExportPage({ authInfo = {} }) {
  const { t } = useTranslation();

  const classes = useStyles();

  const dispatch = useDispatch();

  const {
    location: { pathname: currentLocationPath },
  } = useHistory();

  const userHasAnyRole = useCallback(
    (mainRoles = []) => authInfo?.roles?.some((role) => mainRoles?.find((item) => role?.startsWith(item))),
    [authInfo]
  );

  useEffect(() => {
    const handleFocusLock = () => {
      const currentPaths = currentLocationPath.split('/');

      const match = (modulePaths) => modulePaths.every((path) => currentPaths.includes(path));

      if (match(EXPORTACAO_MODULE)) {
        dispatch(focusLockActions.lock());
      }
    };

    handleFocusLock();
  }, [currentLocationPath]);

  const breadcrumbs = [
    {
      link: {
        to: '/',
        name: t('com.muralis.qcx.inicio'),
      },
    },
    {
      text: {
        name: t('com.muralis.qcx.exportacao.label'),
      },
    },
  ];

  return (
    <QCXMainLayout
      pageIcon={<LabelIcon />}
      pageTitle={t('com.muralis.qcx.exportacao.label')}
      breadcrumbs={breadcrumbs}
      authInfo={authInfo}
    >
      <Grid className={classes.cardMenuContainer} item container justify="center" xs={12} sm={12} md={12} xl={12}>
        <QCXFocusLock>
          <Grid container style={{ maxWidth: '1920px' }}>
            {userHasAnyRole(['exportacao-follow-up']) && (
              <Grid item justify="center" xs={6} sm={4} md={3} lg={3} xl={2} className={classes.active}>
                <QCXCardMenu
                  title={t('com.muralis.qcx.followUpExportacao.label')}
                  link={t('com.muralis.qcx.url.exportacaoFollowUp')}
                  icon={DynamicFeedIcon}
                />
              </Grid>
            )}

            {userHasAnyRole(['exportacao-follow-up']) && (
              <Grid item justify="center" xs={6} sm={4} md={3} lg={3} xl={2} className={classes.active}>
                <QCXCardMenu title="Gestão à vista" link="/exportacao/gestao" icon={DashboardIcon} />
              </Grid>
            )}

            {userHasAnyRole(['exportacao-follow-up']) && (
              <Grid item justify="center" xs={6} sm={4} md={3} lg={3} xl={2} className={classes.active}>
                <QCXCardMenu
                  title={t('com.muralis.qcx.transferenciaLote.label')}
                  link={t('com.muralis.qcx.url.exportacaoTransferenciaLote')}
                  icon={FileCopy}
                />
              </Grid>
            )}

            {userHasAnyRole([NumerarioImportacaoUtils.ROLE]) && (
              <Grid item justify="center" xs={6} sm={4} md={3} lg={3} xl={2} className={classes.active}>
                <QCXCardMenu
                  title={t('com.muralis.qcx.numerarioImportacao.labelPlural')}
                  link="/exportacao/numerario"
                  icon={CalculateIcon}
                />
              </Grid>
            )}

            {userHasAnyRole(['exportacao-dados-embarque']) && (
              <Grid item justify="center" xs={6} sm={4} md={3} lg={3} xl={2} className={classes.active}>
                <QCXCardMenu
                  title={t('com.muralis.qcx.dadosEmbarque.label')}
                  link={t('com.muralis.qcx.url.exportacaoDadosEmbarque')}
                  icon={DynamicFeedIcon}
                />
              </Grid>
            )}

            {userHasAnyRole(['exportacao-due']) && (
              <Grid item justify="center" xs={6} sm={4} md={3} lg={3} xl={2} className={classes.active}>
                <QCXCardMenu
                  title={t('com.muralis.qcx.dueExportacao.sigla')}
                  link={t('com.muralis.qcx.url.exportacaoDue')}
                  icon={ReceiptIcon}
                />
              </Grid>
            )}
            {userHasAnyRole(['exportacao-sda']) && (
              <Grid item justify="center" xs={6} sm={4} md={3} lg={3} xl={2} className={classes.active}>
                <QCXCardMenu title="SDA" link={t('com.muralis.qcx.url.exportacaoSDA')} icon={TableChartIcon} />
              </Grid>
            )}
            {userHasAnyRole(['relatorios-exportacao']) && (
              <Grid item justify="center" xs={6} sm={4} md={3} lg={3} xl={2} className={classes.active}>
                <QCXCardMenu title="Relatórios de Exportação" link="/exportacao/relatorios" icon={InsertDriveFile} />
              </Grid>
            )}
          </Grid>
        </QCXFocusLock>
      </Grid>
    </QCXMainLayout>
  );
}
